import { Navigate, useParams } from 'react-router-dom';
import '../../styles/participant.css';
import { ParticipantSessionFlow } from '../../features/sessions-participant';

export default function ParticipantSessionView() {
  const { sessionId } = useParams<{ sessionId: string }>();

  if (!sessionId) {
    return <Navigate to="/sessions" replace />;
  }

  return (
    <ParticipantSessionFlow
      sessionId={sessionId}
      shell="standalone"
      backPath="/sessions"
    />
  );
}
